module.exports = __webpack_public_path__ + "img/四校戦 2.50794c84.jpg";